import Vue from 'vue'
import router from './router'
import store from './store'
import {
  Message
} from 'element-ui'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import {
  getQueryString,
  isPkgCode
} from '@/utils'

import {
  getToken,
  getUserLocalData
} from '@/utils/auth'
import {
  getUserTag
} from "@/api/base";
import connectSocket from './connectSocket'

NProgress.configure({
  showSpinner: false
})
let allowBack = true //    给个默认值true
let jupiter_token = getQueryString('jupiter_token');
let isLogin = false
let host = window.location.host;
let arrHost = ['http://cn-new.classba.cn', 'http://cn-new.171xue.com', 'https://cn-new.classba.cn', 'https://cn-new.171xue.com'];

const countDownMessage = msg => {
  const vm = new Vue()
  const h = vm.$createElement
  let num = 3
  Message({
    message: h('p', {
      ref: 'timerMsg',
      style: {
        color: '#f56c6c'
      }
    }, msg.pre + num + msg.next),
    type: 'error',
    duration: 3 * 1000
  })

  let timer = setInterval(() => {
    if (num === 0) {
      clearInterval(timer)
    }
    --num
    vm.$refs.timerMsg.innerText = `${msg.pre + num + msg.next}`
  }, 1000)
}
const linkReset = () => {
  setTimeout(() => {
    if (arrHost.indexOf(host) == -1) {
      window.location.href = 'http://test-learn.classba.cn';
    } else {
      window.location.href = 'http://learn.classba.cn';
    }
  }, 3000)
}

const goNext = next => {
  const { id } = store.state.component
  console.log('跳转的路由id-2',id)
  switch (id) {
    case 'index':
      next('/') // 路由路径
      break
    // case 'transition':
    //   next('/footprint') // 流程15 调试用路由路径
    //   break
    case id: // 这里要求页面组件名称定义的时候一定要跟后台返回的一致
      next('/' + id)
      break
    default:
      break
  }
}

router.beforeEach(async (to, from, next) => {
  store.dispatch('icbc/theme/set', 'en')
  NProgress.start();
  if (!to.meta.permission) {
    next(); // 需要验证页面
    if (to.meta.allowBack !== undefined) {
      allowBack = to.meta.allowBack
    }
    if (!allowBack) {
      history.pushState(null, null, location.href)
    }
  } else {
    if (jupiter_token && !isLogin) { //有token且未登录
      let res
      try {
        res = await store.dispatch('login', { jupiterToken: jupiter_token })
        if (!res) throw new Error()
      } catch (err) {
        console.log(err, 'err');
        //  跳转到登录中心
        if (res.code != 200) {
          let msg = {
            pre: '登录失败！',
            next: '秒后请重新登录'
          }
          countDownMessage(msg)
          linkReset();
        }
        NProgress.done()
        return
      }

      connectSocket(res.data)
      isLogin = true

      let {
        isShowTipsAgain,
        hciToken
      } = getUserLocalData();
      localStorage.setItem('isShowTipsAgain', isShowTipsAgain)
      localStorage.setItem('hciToken', hciToken)

      let r
      const cb = () => {
        console.log('路由id',store.state.component)
        router.push({
          path: store.state.component.id,
          query: {
            firstEntry: store.state.component.source.firstEntry
          }
        });
        if(res.data.isGetTag === 1){
          let params = {
            'module_type': store.state.moduleStatus.current[0].moduleType,
            'batch_num': 1,
            'lmsVersion': 'englishRefactoring'
          }
          getUserTag(params)
          .then(res => {
            if (res.code == 200) {
              localStorage.setItem("currentUserTag",res.data.userTag)
            }
          })
          .catch(err => {})
        }
      }
      try {
        r = await store.dispatch('nextStep', { isSubmit: 0, cb: cb })
        if (!r) throw new Error()
      } catch (e) {
        NProgress.done()
        return
      }

      if (!isPkgCode(r.code)) {
        cb()
      }

    } else {
      if (getToken()) {
        if (!isLogin) {

          const cb = () => {
            const userInfo = getUserLocalData()
            connectSocket(userInfo)
            isLogin = true
            goNext(next)
          }

          let res
          try {
            res = await store.dispatch('nextStep', { isSubmit: 0, cb: cb })
            if (!res) throw new Error()
          } catch (e) {
            NProgress.done()
            return
          }

          if (!isPkgCode(res.code)) {
            cb()
          }

        } else {
          next()
        }
      } else {
        let msg = {
          pre: '请先登录！',
          next: '秒后将自动跳转至登录页'
        }
        countDownMessage(msg)
        linkReset();
        NProgress.done()
      }
    }
  }
})

router.afterEach(() => {
  NProgress.done()
})



// WEBPACK FOOTER //
// ./src/permission.js